/* eslint-disable no-unused-vars */

import { store } from 'redux/store';
import { picklistSysNames } from '@redux/slices/picklists/picklists-slice';
import {
  mobileSyncCountApiJsonManipulation,
  mobileSyncCountDispatcher
} from './json-manipulation/mobile-sync-count';
import {
  applicationVersionManipulationJson,
  applicationVersionDispatcher
} from './json-manipulation/application-version';
import {
  equipmentDispatcher,
  equipmentJsonManipulationJson,
  newAndEditedSyncedEquipmentDispatcher,
  newAndEditedSyncedEquipmentManipulationJson
} from './json-manipulation/equipment';
import { psvsDispatcher, psvsJsonManipulation } from './json-manipulation/psvs';
import {
  jurisdictionNumbersDispatcher,
  jurisdictionNumbersJsonManipulation
} from './json-manipulation/jurisdiction-numbers';
import { bookmarksDispatcher, bookmarksJsonManipulationJson } from './json-manipulation/bookmarks';
import { siteJsonManipulationJson, sitesDispatcher } from './json-manipulation/site';
import { pipelineDispatcher, pipelineJsonManipulationJson } from './json-manipulation/pipeline';
import { structureDispatcher, structureJsonManipulationJson } from './json-manipulation/structure';
import {
  assetLastInspectionDateMap,
  assetLastInspectionDateMapDispatcher,
  inspectionInspectorUserGroups,
  inspectionInspectorUserGroupsDispatcher,
  inspectionInspectorUsers,
  inspectionInspectorUsersDispatcher,
  pass_deficiency_fail,
  pass_deficiency_failDispatcher,
  pass_fail_list,
  pass_fail_listDispatcher,
  workOrderAdministratorGroups,
  workOrderAdministratorGroupsDispatcher,
  workOrderAdministrators,
  workOrderAdministratorsDispatcher,
  workOrderUserGroups,
  workOrderUserGroupsDispatcher,
  workOrderUsers,
  workOrderUsersDispatcher
} from './json-manipulation/work-order-users';
import {
  inspectionTypeManipulationJson,
  inspectionTypesAndCheckTypesDispatcher
} from './json-manipulation/inspection-type';
import { hseEventDispatcher, hseEventManipulationJson } from './json-manipulation/hse-event';
import {
  equipmentFormDispatcher,
  equipmentFormManipulationJson,
  inspectionForManipulationJson,
  inspectionFormDispatcher
} from './json-manipulation/inspection-forms';
import {
  mobileUsersDataDispatcher,
  mobileUsersDataManipulationJson,
  picklistDataDispatcher,
  picklistDataManipulationJson
} from './json-manipulation/picklists';
import { settingDataDispatcher, settingDataManipulation } from './json-manipulation/setting';
import {
  companySupportDispatcher,
  companySupportManipulationJson
} from './json-manipulation/company-support';

export const allAPIsList = ({
  initialLogin = false,
  lastSuccessFullRefreshTime = null,
  settingsUpdated
}) => {
  const changedAfter = lastSuccessFullRefreshTime;
  const { cache, inspection } = store.getState();
  const { equipments = [], sites = [], syncedNewAndEditedEquipments = [] } = cache;

  return [
    // 1
    {
      URL: `/MobileSync/SyncCount?changedAfter=${
        !initialLogin ? (changedAfter ? changedAfter : '') : ''
      }`,
      description: 'get data count from mobile sync count API',
      method: 'GET',
      key: 'MobileSync/SyncCount',
      parser: mobileSyncCountApiJsonManipulation,
      dispatcher: mobileSyncCountDispatcher
    },

    // 2
    {
      URL: `/ApplicationVersion`,
      description: 'get latest version of application',
      method: 'GET',
      key: 'ApplicationVersion',
      parser: applicationVersionManipulationJson,
      dispatcher: applicationVersionDispatcher
    },

    // 3
    {
      URL: `/Equipment/mobile?page=0&changedAfter=${
        !initialLogin ? (changedAfter ? (equipments?.length === 0 ? '' : changedAfter) : '') : ''
      }`,
      description: 'get equipment mobile cache list',
      method: 'GET',
      key: 'Equipment/mobile',
      parser: equipmentJsonManipulationJson,
      dispatcher: equipmentDispatcher
    },

    // 4
    {
      URL: `/PVPSV/mobile?page=0`,
      description: 'get equipment psvs list',
      method: 'GET',
      key: 'PVPSV/mobile',
      parser: psvsJsonManipulation,
      dispatcher: psvsDispatcher
    },

    // 5
    {
      URL: `/JurisdictionNumbers?page=0`,
      description: 'get equipment jurisdiction numbers list',
      method: 'GET',
      key: 'JurisdictionNumbers',
      parser: jurisdictionNumbersJsonManipulation,
      dispatcher: jurisdictionNumbersDispatcher
    },

    // 6
    {
      URL: `/Bookmarks?page=0`,
      description: 'get default bookmarks list',
      method: 'GET',
      key: 'Bookmarks',
      parser: bookmarksJsonManipulationJson,
      dispatcher: bookmarksDispatcher
    },

    // 7
    {
      URL: `/Sites/mobile?page=0&changedAfter=${
        !initialLogin ? (changedAfter ? (sites?.length === 0 ? '' : changedAfter) : '') : ''
      }`,
      description: 'get sites cache list',
      method: 'GET',
      key: 'Sites/mobile',
      parser: siteJsonManipulationJson,
      dispatcher: sitesDispatcher
    },

    // 8
    {
      URL: `/Pipelines/Mobile?page=0&changedAfter=${
        !initialLogin ? (changedAfter ? changedAfter : '') : ''
      }`,
      description: 'get pipeline cache list',
      method: 'GET',
      key: 'Pipelines/Mobile',
      parser: pipelineJsonManipulationJson,
      dispatcher: pipelineDispatcher
    },

    // 9
    {
      URL: `/Structures/Mobile?page=0&changedAfter=${
        !initialLogin ? (changedAfter ? changedAfter : '') : ''
      }`,
      description: 'get structure cache list',
      method: 'GET',
      key: 'Structures/Mobile',
      parser: structureJsonManipulationJson,
      dispatcher: structureDispatcher
    },

    // 10
    {
      URL: '/WorkOrderUsers',
      description: 'get work order users list',
      method: 'GET',
      key: 'WorkOrderUsers',
      parser: workOrderUsers,
      dispatcher: workOrderUsersDispatcher
    },

    // 11
    {
      URL: '/WorkOrderUserGroups',
      description: 'get work order users groups list',
      method: 'GET',
      key: 'WorkOrderUserGroups',
      parser: workOrderUserGroups,
      dispatcher: workOrderUserGroupsDispatcher
    },

    // 12
    {
      URL: '/WorkOrderAdministrators',
      description: 'get work order administrators list',
      method: 'GET',
      key: 'WorkOrderAdministrators',
      parser: workOrderAdministrators,
      dispatcher: workOrderAdministratorsDispatcher
    },

    // 13
    {
      URL: '/WorkOrderAdministratorGroups',
      description: 'get work order administrators groups list',
      method: 'GET',
      key: 'WorkOrderAdministratorGroups',
      parser: workOrderAdministratorGroups,
      dispatcher: workOrderAdministratorGroupsDispatcher
    },

    // 14
    {
      URL: '/InspectionTypes/?page=0',
      description: 'get inspection types list',
      method: 'GET',
      key: 'InspectionTypesAndCheckTypes',
      parser: inspectionTypeManipulationJson,
      dispatcher: inspectionTypesAndCheckTypesDispatcher
    },

    // 15
    {
      URL: '/InspectionInspectorUserGroups/?page=0',
      description: 'get inspection inspector user groups list',
      method: 'GET',
      key: 'InspectionInspectorUserGroups',
      parser: inspectionInspectorUserGroups,
      dispatcher: inspectionInspectorUserGroupsDispatcher
    },

    // 16
    {
      URL: '/InspectionInspectorUsers/?page=0',
      description: 'get inspection inspector user list',
      method: 'GET',
      key: 'InspectionInspectorUsers',
      parser: inspectionInspectorUsers,
      dispatcher: inspectionInspectorUsersDispatcher
    },

    // 17
    {
      URL: '/InspectionSchedules/mobile',
      description: 'get inspection schedules mobile list',
      method: 'GET',
      key: 'InspectionSchedules',
      parser: assetLastInspectionDateMap,
      dispatcher: assetLastInspectionDateMapDispatcher
    },

    // 18
    {
      URL: '/SyncedHSECache/MobileCache',
      description: 'get synced hse event list',
      method: 'GET',
      key: 'SyncedHSECache/MobileCache',
      parser: hseEventManipulationJson,
      dispatcher: hseEventDispatcher
    },

    // 19
    {
      URL: `/InspectionForms/UserCache?page=0&changedAfter=${
        !initialLogin
          ? changedAfter
            ? inspection?.inspectionFormsUserCache?.length === 0
              ? ''
              : changedAfter
            : ''
          : ''
      }`,
      description: 'get inspection forms user cache list',
      method: 'GET',
      key: 'InspectionForms/UserCache',
      parser: inspectionForManipulationJson,
      dispatcher: inspectionFormDispatcher
    },
    // 20
    {
      URL: `/WorkOrderCache/MobileCache?page=0`,
      description: 'get inspection forms user cache list',
      method: 'GET',
      key: 'WorkOrderCache/MobileCache'
    },

    // 21
    {
      URL: `/SyncedWorkOrderCache/MobileCache?page=0`,
      description: 'get inspection forms user cache list',
      method: 'GET',
      key: 'SyncedWorkOrderCache/MobileCache'
    },

    // 22
    {
      URL: `/InspectionCache/MobileCache?page=0`,
      description: 'get inspection forms user cache list',
      method: 'GET',
      key: 'InspectionCache/MobileCache'
    },

    // 23
    {
      URL: `/SyncedInspectionCache/MobileCache?page=0`,
      description: 'get inspection forms user cache list',
      method: 'GET',
      key: 'SyncedInspectionCache/MobileCache'
    },

    // 24
    {
      URL: `/AssignedAssetCheckCache/MobileCache`,
      description: 'get inspection forms user cache list',
      method: 'GET',
      key: 'AssignedAssetCheckCache/MobileCache'
    },

    // 25
    {
      URL: `/SyncedAssetCheckCache/MobileCache`,
      description: 'get inspection forms user cache list',
      method: 'GET',
      key: 'SyncedAssetCheckCache/MobileCache'
    },

    // 26
    {
      URL: `/Picklists/staticLists?type=pass_fail_list`,
      description: 'get inspection forms user cache list',
      method: 'GET',
      key: 'pass_fail_list',
      parser: pass_fail_list,
      dispatcher: pass_fail_listDispatcher
    },
    // 27
    {
      URL: `/Picklists/staticLists?type=pass_deficiency_fail`,
      description: 'get inspection forms user cache list',
      method: 'GET',
      key: 'pass_deficiency_fail',
      parser: pass_deficiency_fail,
      dispatcher: pass_deficiency_failDispatcher
    },

    {
      URL: `Picklists/mobile?page=0`,
      description: 'get inspection forms user cache list',
      method: 'POST',
      key: 'Picklists',
      body: [...picklistSysNames],
      parser: picklistDataManipulationJson,
      dispatcher: picklistDataDispatcher
    },

    {
      URL: `Users/mobile`,
      description: 'get all users names and email addresses',
      method: 'GET',
      key: 'Users/mobile',
      parser: mobileUsersDataManipulationJson,
      dispatcher: mobileUsersDataDispatcher
    },

    ...(settingsUpdated
      ? [
          {
            URL: `UserMobileSettings`,
            description: 'get inspection forms user cache list',
            method: 'GET',
            key: 'UserMobileSettings',
            parser: settingDataManipulation,
            dispatcher: settingDataDispatcher
          }
        ]
      : []),

    {
      URL: `/CompanySupport`,
      description: 'get latest text of company support',
      method: 'GET',
      key: 'CompanySupport',
      parser: companySupportManipulationJson,
      dispatcher: companySupportDispatcher
    },

    {
      URL: `/InspectionForms/additionalfields?assetType=Equipment`,
      description: 'get equipment all additional fields for new and assigned equipment',
      method: 'GET',
      key: 'InspectionForms/additionalfields',
      parser: equipmentFormManipulationJson,
      dispatcher: equipmentFormDispatcher
    },

    // 18
    {
      URL: `/ReconciliationRecords/mobilecache?changedAfter=${
        !initialLogin
          ? changedAfter
            ? syncedNewAndEditedEquipments?.length === 0
              ? ''
              : changedAfter
            : ''
          : ''
      }`,
      description: 'get synced new and existing equipment',
      method: 'GET',
      key: 'ReconciliationRecords/mobilecache',
      parser: newAndEditedSyncedEquipmentManipulationJson,
      dispatcher: newAndEditedSyncedEquipmentDispatcher
    }
  ];
};
